import axios from 'axios'
import { camelizeKeys } from 'humps'
import config from '../utils/config'
const fileDownload = require('react-file-download')

const GENERAL_ENDPOINT_API = config.api[process.env.NODE_ENV].general
//const GENERAL_ENDPOINT = config.api[process.env.NODE_ENV].pre
const GENERAL_ENDPOINT = config.api[process.env.NODE_ENV].hc360
const HC_360_ENDPOINT = config.api[process.env.NODE_ENV].hc360

/**
|--------------------------------------------------
| [GET] List Company
|--------------------------------------------------
*/
export const getCompanies = () =>
  axios.get(`${GENERAL_ENDPOINT}/Companies`).then(response => response.data)

/**
|--------------------------------------------------
| [GET] List Departments
|--------------------------------------------------
*/
export const getDepartments = companyId =>
  axios
    .get(`${GENERAL_ENDPOINT}/Companies/${companyId}/Departments`)
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] List Company hc 360
|--------------------------------------------------
*/
export const getCompaniesHc360 = () =>
  axios.get(`${HC_360_ENDPOINT}/Companies`).then(response => response.data)

/**
|--------------------------------------------------
| [GET] List Departments
|--------------------------------------------------
*/
export const getDepartmentsHc360 = companyId =>
  axios
    .get(`${HC_360_ENDPOINT}/Companies/${companyId}/Departments`)
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Country
|--------------------------------------------------
*/
export const getCountry = (page, pageSize) =>
  axios
    .get(`${GENERAL_ENDPOINT}/Country`, {
      headers: {
        page,
        pageSize
      }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Province
|--------------------------------------------------
*/
export const getProvince = (countryID, page, pageSize) =>
  axios
    .get(`${GENERAL_ENDPOINT}/Country/${countryID}/Province`, {
      headers: { page, pageSize }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] District
|--------------------------------------------------
*/
export const getDistrict = (provinceID, page, pageSize) =>
  axios
    .get(`${GENERAL_ENDPOINT}/Province/${provinceID}/District`, {
      headers: { page, pageSize }
    })
    .then(response => response.data)

/**
|--------------------------------------------------
| [GET] Export Employees
|--------------------------------------------------
*/
export const exportEmployees = () =>
  axios
    .get(`${GENERAL_ENDPOINT_API}/employee/export?companyID=`)
    .then(response => fileDownload(response, 'Employees.xlsx'))
/*
  |--------------------------------------------------
  | [GET] List Departments
  |--------------------------------------------------
  */
export const getHolidays = (params = {}) =>
  axios
    .get(`${HC_360_ENDPOINT}/Holiday`, {
      // eslint-disable-next-line prettier/prettier
      headers: { ...params }
    })
    .then(response => response.data)
/*
  |--------------------------------------------------
  | [GET] List Departments
  |--------------------------------------------------
  */
export const listUserReceiveVote = filter =>
  axios
    .get(`${GENERAL_ENDPOINT_API}/vote/candidate`, {
      params: filter
    })
    .then(response => camelizeKeys(response.data))
/*
  |--------------------------------------------------
  | [GET] Vote infomation
  |--------------------------------------------------
  */
export const listUserGiveVote = filter =>
  axios
    .get(`${GENERAL_ENDPOINT_API}/vote/information`, {
      params: filter
    })
    .then(response => camelizeKeys(response.data))
/*
  |--------------------------------------------------
  | [GET] Get vote report
  |--------------------------------------------------
  */
export const getVoteReport = filter =>
  axios({
    url: `${GENERAL_ENDPOINT_API}/vote/report`,
    method: 'GET',
    headers: {
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    responseType: 'blob',
    crossdomain: true,
    params: filter
  })



// WEBPACK FOOTER //
// ./src/api/general.js